/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paymentMethodIndexDataSchema = z.object({
	profileId: z.string().uuid().nullable().optional(),
})

export type PaymentMethodIndexDataSchema = z.infer<typeof paymentMethodIndexDataSchema>
